import { render, staticRenderFns } from "./on_boarding_table.vue?vue&type=template&id=07bd2781&scoped=true"
import script from "./on_boarding_table.vue?vue&type=script&lang=js"
export * from "./on_boarding_table.vue?vue&type=script&lang=js"
import style0 from "./on_boarding_table.vue?vue&type=style&index=0&id=07bd2781&prod&lang=css"
import style1 from "./on_boarding_table.vue?vue&type=style&index=1&id=07bd2781&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bd2781",
  null
  
)

export default component.exports